export const isEmptyValue = (value: unknown): value is null | undefined => {
  return value == null || isNaN(Number(value))
}
